module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "buttonStyle": "primary",
      "heading": "Agreement",
      "showText": _vm.showText,
      "size": "default",
      "button-size": "mini",
      "buttonText": "Agreement",
      "buttonIcon": "fa fa-asterisk",
      "disableButton": !_vm.isManager('finance|admin|management')
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('agreement-details', {
    attrs: {
      "adding": "",
      "row-data": _vm.rowData
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a43f4fd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/AgreementAction.vue
// module id = 1684
// module chunks = 0